export default __webpack_public_path__ + "86cfb806379cbecfefda05d8e71b7f90.svg";